import { connect } from 'react-redux';
import { getUserConfiguration } from './../reducers/profile';
import NavBarComponent from './../Components/NavBarComponent.jsx';

export const mapStateToProps = (state) => {
  return getUserConfiguration(state);
};

export default connect(
  mapStateToProps,
)(NavBarComponent);


// WEBPACK FOOTER //
// src/Containers/NavBarContainer.jsx